import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { HashRouter as Router, Redirect, Route, Switch } from 'react-router-dom'

import { useSelector, useDispatch } from 'react-redux'
import {
  setUserToState,
  setAuthToState,
  selectAuth,
} from './features/auth/authSlice'

import Registraion from './components/registration'
import Login from './components/login'

// import blogdata from "./data/blogdata.json";
// import Singleblogdata from "./data/single-blogdata.json";
// import HomeV1 from "./components/home-v1";
import Dashboard from './Dashboard/Dashboard'
// import HomeV2 from "./components/home-v2";
// import HomeV3 from "./components/home-v3";
// import HomeV4 from "./components/home-v4";

//pages
import Project1 from './components/project'
import Project2 from './components/project2'
import Project3 from './components/project3'
import Property from './components/property'
import AvilableProperty from './components/availavbe-property'
import PropertiesByCity from './components/properties-by-city'
import RecentProperties from './components/recent-properties'
import PropertyDetails from './components/property-details'
import About from './components/about'
import Advisor from './components/advisor'
import Pricing from './components/pricing'
import UserList from './components/user-list'
import Error from './components/error'
import Faq from './components/faq'
import News from './components/news'
import NewsDetails from './components/news-details'
import Contact from './components/contact'
import SearchMap from './components/search-map'
import SearchGrid from './components/search-grid'
import SearchList from './components/search-list'
import AddNew from './components/add-property'
import Maps from './components/Maps/Maps'
import Career from './components/career/careers'
import './web.config'
import SocialMediaBar from './components/section-components/socialMediaBar'
import useFetch from './Hooks/useFetch'

//redux
import store from './store'
import { Provider } from 'react-redux'

//components
import Toolbar from './components/section-components/toolbar/index'

//lazy load
const HomeV1 = React.lazy(() => import('./components/home-v1'))

class Root extends Component {
  render() {
    return (
      <Provider store={store}>
        <React.Suspense fallback={<div></div>}>
          <Router>
            {/* <Toolbar /> */}
            <SocialMediaBar />
            <div>
              <Switch>
                <Route exact path='/' component={HomeV1} />
                {/* <Route path="/home-v2" component={HomeV2} />
              <Route path="/home-v3" component={HomeV3} />
              <Route path="/home-v4" component={HomeV4} /> */}

                {/* Login registration */}
                <Route path='/registration' component={Registraion} />
                <Route path='/login' component={Login} />

                <Route path='/property' component={Property} />
                <Route
                  path='/availavbe-property'
                  component={AvilableProperty}
                />
                <Route
                  path='/properties-by-city'
                  component={PropertiesByCity}
                />
                {/* {myProjects?.map((project) => (
                  <Route
                    path={`/project${project.sys.id}`}
                    component={Project1}
                  />
                ))} */}
                <Route path='/project1' component={Project1} />
                {/* <Route path="/project2" component={Project2} />
                <Route path="/project3" component={Project3} /> */}

                <Route path='/recent-properties' component={RecentProperties} />
                <Route path='/property-details' component={PropertyDetails} />
                <Route path='/about' component={About} />
                <Route path='/advisor' component={Advisor} />
                <Route path='/pricing' component={Pricing} />
                <Route path='/user-list' component={UserList} />
                <Route path='/error' component={Error} />
                <Route path='/faq' component={Faq} />
                <Route path='/news' component={News} />
                <Route path='/news-details' component={NewsDetails} />
                <Route path='/contact' component={Contact} />
                <Route path='/search-map' component={SearchMap} />
                <Route path='/search-grid' component={SearchGrid} />
                <Route path='/search-list' component={SearchList} />
                <Route path='/add-property' component={AddNew} />
                <Route path='/maps' component={Maps} />
                <Route path='/careers' component={Career} />
                <PrivateRoute component={Dashboard} path='/dashboard' exact />
              </Switch>
            </div>
          </Router>
        </React.Suspense>
      </Provider>
    )
  }
}

const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)

  const setAuth = () => {
    const user = JSON.parse(localStorage.getItem('user'))
    const auth = JSON.parse(localStorage.getItem('auth'))

    if (auth) {
      dispatch(setUserToState(user.data))
      dispatch(setAuthToState(auth))
    }
  }

  React.useEffect(() => {
    setAuth()
  }, [])

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        JSON.parse(localStorage.getItem('auth')).status ? (
          <Component {...props} />
        ) : (
          <Redirect to='/login' />
        )
      }
    />
  )
}

export default Root

ReactDOM.render(<Root />, document.getElementById('realdeal'))
